import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'

interface IRemoveColorModalProps extends RouteComponentProps {
  setting: { label: string; id: string }
  id: string
  removeVehicleColor: (id: string) => Promise<any>
}

export default class RemoveColorModal extends React.Component<IRemoveColorModalProps> {
  public render() {
    return (
      <SettingRemoveModal
        setting={this.props.setting ? this.props.setting : { label: '', id: '' }}
        settingType='Color'
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    this.props.removeVehicleColor(this.props.id).then(() => {
      setTimeout(() => {
        this.onClose()
      }, 1000)
    })
  }

  private onClose = () => {
    this.props.history.push('/global-settings/color')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveColorModal.tsx